import {FDS_SUCCESS_SUB_PATH} from './constants'

export const PAYMENT_METHODS_ROUTES = {
    MAIN: '/paymentMethods',
    DICON_AUTO: {
        /** 디지털콘텐츠 정기결제 주문서 */
        MAIN: '/paymentMethods/digitalcontents',
        /** 등록 결과 연동 */
        RESULT: '/paymentMethods/digitalcontents/result',
        BRIDGE: {
            MAIN: '/paymentMethods/digitalcontents/bridge',
            /** FDS 결과 연동 */
            FDS_AUTH_BRIDGE: '/paymentMethods/digitalcontents/bridge/fds',
            /** 휴대폰 일반결제 인증 결과 연동 페이지 */
            MOBILE_PAYMENT_BRIDGE: '/paymentMethods/digitalcontents/bridge/mobilePayment',
            /** 주문서 Popup 에서 결과를 opener 로 전달받는 BridgePage */
            POPUP_BRIDGE: '/paymentMethods/digitalcontents/bridge/popup',
            /** FDS - ARS 인증 후 휴대폰 결제 모듈로 연결하는 bridgePage */
            ARS_MOBILE_BRIDGE: '/paymentMethods/digitalcontents/bridge/ars',
        },
    },
    DICON_PAYMENT: {
        /** 디지털콘텐츠 단건결제 주문서 */
        MAIN: '/digitalContents/buy',
        CHECKOUT: '/digitalContents/buy/checkout',
        /** 등록 결과 연동 */
        APPLY: `/digitalContents/buy/${FDS_SUCCESS_SUB_PATH}`,
    },
    BRIDGE: {
        ADD_PAYMENT_METHOD: '/paymentMethods/bridge/popup',
    },
}
